import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { SITE } from "@/data/site";
import { VILLES } from "@/data/villes";
import { SERVICES } from "@/data/services";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-navy text-white mt-0" style={{ color: "var(--white)" }} data-testid="site-footer">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Colonne marque */}
          <div>
            <Link to="/" className="flex items-center mb-4" aria-label="DS Serrurier — DS Serrurier Urgence, accueil">
              <Logo variant="footer" />
            </Link>
            <p className="text-sm text-white/70 leading-relaxed mb-4" style={{ color: "rgba(255,255,255,0.7)" }}>
              Serrurier de ville basé à Puteaux. Interventions d'urgence 7j/7 et travaux de sécurisation dans toute l'Île-de-France.
            </p>
            <div className="space-y-2 text-sm">
              <a
                href={SITE.telephoneHref}
                className="flex items-center gap-2 hover:text-orange transition-colors"
                style={{ color: "var(--white)" }}
                data-testid="footer-phone"
              >
                <Phone size={16} />
                <span className="font-mono">{SITE.telephone}</span>
              </a>
              <div className="flex items-center gap-2 text-white/70" style={{ color: "rgba(255,255,255,0.7)" }}>
                <MapPin size={16} />
                <span>{SITE.adresse}</span>
              </div>
              <div className="flex items-center gap-2 text-white/70" style={{ color: "rgba(255,255,255,0.7)" }}>
                <Mail size={16} />
                <span className="font-mono text-xs">{SITE.email}</span>
              </div>
              <a
                href={SITE.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-orange transition-colors"
                style={{ color: "var(--white)" }}
                data-testid="footer-facebook"
              >
                <Facebook size={16} />
                <span>Facebook</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-extrabold uppercase text-sm tracking-wider mb-4" style={{ color: "var(--brass-light)" }}>
              Services
            </h3>
            <ul className="space-y-2 text-sm">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-white/80 hover:text-white transition-colors"
                    style={{ color: "rgba(255,255,255,0.8)" }}
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {s.titre}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Villes */}
          <div>
            <h3 className="font-heading font-extrabold uppercase text-sm tracking-wider mb-4" style={{ color: "var(--brass-light)" }}>
              Villes desservies
            </h3>
            <ul className="space-y-2 text-sm">
              {VILLES.map((v) => (
                <li key={v.slug}>
                  <Link
                    to={`/serrurier-${v.slug}`}
                    className="text-white/80 hover:text-white transition-colors"
                    style={{ color: "rgba(255,255,255,0.8)" }}
                    data-testid={`footer-ville-${v.slug}`}
                  >
                    Serrurier {v.nom}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/zones-intervention"
                  className="text-brass hover:text-orange font-mono text-xs uppercase tracking-wider"
                  style={{ color: "var(--brass-light)" }}
                >
                  → Toutes les zones
                </Link>
              </li>
            </ul>
          </div>

          {/* Infos */}
          <div>
            <h3 className="font-heading font-extrabold uppercase text-sm tracking-wider mb-4" style={{ color: "var(--brass-light)" }}>
              Informations
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/tarifs" className="text-white/80 hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.8)" }}>
                  Tarifs & Offres
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.8)" }}>
                  Blog & Conseils
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/80 hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.8)" }}>
                  Questions fréquentes
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.8)" }}>
                  Devis gratuit
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-white/80 hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.8)" }}>
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" className="text-white/80 hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.8)" }}>
                  Politique de confidentialité
                </Link>
              </li>
            </ul>

            <div className="mt-6 p-4 border border-white/15 rounded font-mono text-xs" style={{ color: "rgba(255,255,255,0.7)" }}>
              <div className="text-brass mb-1" style={{ color: "var(--brass-light)" }}>HORAIRES</div>
              <div>{SITE.horaires}</div>
              <div className="mt-2" style={{ color: "var(--orange-on-dark)" }}>
                Urgences 24/24 · Interventions planifiées : nous consulter
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs font-mono" style={{ color: "rgba(255,255,255,0.6)" }}>
          <div>© {new Date().getFullYear()} {SITE.nom} · Tous droits réservés</div>
          <div className="uppercase tracking-wider">
            SIRET : {SITE.siret}
          </div>
        </div>
      </div>
    </footer>
  );
}
